<template>
  <div class="favorites-button" @click="showModal">
    <BbIcon class="favorites-icon" name="heart" type="filled" size="small" />
    <div v-if="favoriteDocumentsCount" class="favorites-count">
      {{ favoriteDocumentsCount }}
    </div>
  </div>
</template>

<script>
import useModals from '~/composables/useModals';
import useCollections from '~/composables/useCollections';
import { CURRENT_DIALOG } from '~/constants/conversationModels';

export default {
  name: 'FavoritesMenu',
  components: {},

  setup() {
    const { setCurrentDocumentsDialog } = useModals();
    const { favoriteDocumentsCount } = useCollections();
    const showModal = () => {
      setCurrentDocumentsDialog(CURRENT_DIALOG.favorites_panel);
    };

    return {
      favoriteDocumentsCount,
      showModal,
    };
  },
};
</script>

<style scoped lang="scss">
.favorites-button {
  position: relative;
  padding: $bb-spacing-2;
  border-radius: 100px;
  cursor: pointer;
  border: 1px solid $bb-neutral-4;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: inherit;
  justify-content: center;

  .favorites-icon {
    color: $bb-neutral-1;
  }

  .favorites-count {
    @include bb-medium-text-styles('xs');
    color: $bb-neutral-1;
    background-color: $bb-neutral-0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: -4px;
    right: -6px;
    width: 18px;
    height: 16px;
    border: 1px solid $bb-neutral-4;
    border-radius: 100px;
  }
}
</style>
